import axios from 'axios'
import { CATALOGO_ENDPOINT } from 'common/endpoints'

export async function getPaginatedListStock({ search, cancelToken }) {
    let { data } = await axios.get(
        `${CATALOGO_ENDPOINT}/${search}`,
        { cancelToken }
    )
    data.data = data.data.map(stock => {
        let formattedBillDate = null
        if (stock.bill_date) {
            const billDate = new Date(stock.bill_date)
            formattedBillDate = `${billDate.getUTCDate()}/${billDate.getUTCMonth() +
                1}/${billDate.getUTCFullYear()}`
        }
        return {
            ...stock,
            car_lot_name: stock.car_lot || 'SIN DATOS',
            published: stock.published ? 'Publicado' : 'No publicado',
            bill_date: formattedBillDate
        }
    })
    return data
}
